import {requirePermission} from '@/modules/auth/permissions'
import {createFileRoute} from '@tanstack/react-router'

export const Route = createFileRoute('/configuration/locations/new')({
  beforeLoad: requirePermission('organisation.manage'),
  component: RouteComponent,
})

function RouteComponent() {
  return <div>Hello "/configuration/locations/new"!</div>
}
